import React from 'react';

import './parts/vietjet.scss';
import { PageHeader, PageFooter } from './parts/com';
import { Container, Row, Col } from 'react-bootstrap';
import { withRouter, NavLink } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';

class Closed extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			modal: false,
			errorMessage: null,
			lang: this.props.match.params.lang || 'en'
		};

		this.props.i18n.changeLanguage(this.props.match.params.lang);
  }
  
  changeLanguage = nextLang => {
		const { children, i18n, t, history, match } = this.props;
    const newUrl = `${match.path.replace(':lang',nextLang)}`;
    history.push(newUrl);
		i18n.changeLanguage(nextLang);
	};
	
  handleClickSelectLanguage = (lang) => {
		this.changeLanguage(lang);
		this.setState({lang:lang});
	};

	render() {
		const { t, i18n } = this.props;
		return(
		<div className="app">
			<PageHeader handleClickSelectLanguage={this.handleClickSelectLanguage} lang={this.state.lang} t={t} />
			<Container className={'mt-5'}>
				<Row className={'mb-3'}>
					<Col>
						<h1>{t('pages.closed.title')}</h1>
					</Col>
				</Row>
				<Row className={'mb-5'}>
					<Col>
						{t('pages.closed.description')}
						<a
							href={t('pages.closed.action.url')}
							className={'btn btn-submit mt-5 w-50'}
							style={{ display: 'block' }}
						>
							{t('pages.closed.action.label')}
						</a>
					</Col>
				</Row>
			</Container>
			<PageFooter t={t} />
		</div>);
	}
}

/* export default Closed; */
export default withRouter(withTranslation('common')(Closed));
